import React from 'react';
import { I18n } from '@aws-amplify/core';

import { useBeraReportV2 } from '@/context/BeraReportV2';

import { Evaluation } from './Evaluation';
import { EvaluationPlaceholder } from './styles';

export function EvaluationArea(): JSX.Element {
	const { selectedReport, onReportSaved } = useBeraReportV2();

	if (selectedReport) {
		return <Evaluation key={selectedReport.id} report={selectedReport} onFinished={onReportSaved} />;
	}

	return <EvaluationPlaceholder>{I18n.get('Select the task to start the evaluation')}</EvaluationPlaceholder>;
}
